<template>
  <auth-layout>
    <card v-if="spinning">
      <div class="row">
        <div class="col-sm-12 text-center">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>
      </div>
    </card>
    <div class="row d-flex justify-content-center">
      <div class="col-md-8">
        <div class="header-test">
          <h2 style="color: white; margin-left: 200px">
            Hilo Aviation Validation Page
          </h2>
        </div>
      </div>
      <div class="col-md-12 ml-auto">
        <fade-render-transition :duration="200">
          <div class="media">
            <div class="media-left">
              <div class="icon">
                <i class="nc-icon nc-circle-09"></i>
              </div>
            </div>
            <div
              class="row d-flex justify-content-center"
              style="margin-left: 370px"
            >
              <div class="col-sm-12 text-center">
                <div
                  style="color: white"
                  class="valid-txt"
                  v-html="validation_text"
                ></div>
              </div>
            </div>
          </div>
        </fade-render-transition>
        <fade-render-transition :delay="200" :duration="200">
          <div class="media"></div>
        </fade-render-transition>
        <fade-render-transition :delay="400" :duration="200">
          <div class="media">
            <div class="media-left"></div>
            <div class="media-body">
              <h4></h4>
              <p></p>
            </div>
          </div>
        </fade-render-transition>
      </div>
      <div class="col-md-4 mr-auto"></div>
    </div>
    <el-dialog center title="Error" :visible.sync="modals.error">
      <div class="text-center">
        <span>Error: {{ error_txt }}</span>
        <br />
        <span slot="footer" class="dialog-footer">
          <button class="btn bnt-ok" @click="closeModal('error')">OK</button>
        </span>
      </div>
    </el-dialog>
    <el-dialog center title="Success" :visible.sync="modals.success">
      <div class="text-center">
        <span>Success: {{ response_txt }}</span>
        <br />
        <span slot="footer" class="dialog-footer">
          <button class="btn bnt-ok" @click="closeModal('success')">OK</button>
        </span>
      </div>
    </el-dialog>
  </auth-layout>
</template>
<script>
import AuthLayout from "./AuthLayout.vue";
import UsersAPIService from "../../../servicehandlers/UsersAPIService";
const usersAPIService = new UsersAPIService();
import { Dialog, Button } from "element-ui";
import FadeRenderTransition from "../../../components/Transitions/FadeRenderTransition.vue";
export default {
  name: "Validate",
  components: {
    FadeRenderTransition,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    AuthLayout,
  },
  data() {
    return {
      spinning: false,
      response_txt: null,
      error_txt: null,
      validation_text: null,
      modals: {
        error: false,
        success: false,
      },
      props: {
        duration: {
          type: Number,
          required: true,
        },
      },
    };
  },
  mounted() {
    this.validateUser();
  },
  methods: {
    validateUser() {
      if (!this.$route.query.key) {
        this.error_txt = "Invalid key";
        this.openModal("error");
        return;
      }
      if (
        this.$route.query &&
        this.$route.query.key &&
        this.$route.query.key.length <= 5
      ) {
        this.error_txt = "Invalid key";
        this.openModal("error");
        return;
      }
      return usersAPIService
        .validateUser(this.$route.query.key, this.$router)
        .then((validation_string) => {
          this.validation_text = validation_string;
        })
        .catch((error) => {
          this.error_txt = "An unexpected error has occurred " + error.message;
          this.openModal("error");
        });
    },
    goToLogin() {
      this.$router.push({
        name: "Login",
      });
    },
    openModal(name) {
      this.modals[name] = true;
    },
    closeModal(name) {
      this.modals[name] = false;
    },
  },
};
</script>

<style>
.valid-txt {
  //color: dimgray;
  font-size: 18px;
}
</style>
